import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'page-tasks-search',
  styles: ['./page-tasks-search.scss'],
  templateUrl: 'page-tasks-search.html'
})

export class TasksPageSearch {
  public searchTerm: string = '';
  canClearSearch: boolean = false;
  hasSearched: string = "";
  @Output() updateAction = new EventEmitter<string>();

  updateSearchTerm(event){ 
    this.searchTerm = event.target.value;
  }

  clearPreviousSearchTerm() {
    if (this.canClearSearch) {
      this.searchTerm = "";
      this.canClearSearch = false;
    }
  }

  returnPreviousSearchTerm() {
    if (this.hasSearched.length > 0) {
      if (this.searchTerm == "") {
        this.searchTerm = "" + this.hasSearched;
        this.canClearSearch = true;
      }
    }
  }

  submit(){
    this.updateAction.emit(this.searchTerm);
    this.canClearSearch = true;
    this.hasSearched = this.searchTerm;
  }
}



// WEBPACK FOOTER //
// ./src/pages/tasks/components/search/page-tasks-search.ts